export default __webpack_public_path__ + "static/media/digitos.8887da9e.jpg";